import { watch as S, computed as j, toValue as a, unref as C } from "vue";
const I = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const L = Object.prototype.toString, O = (t) => L.call(t) === "[object Object]", y = () => {
};
function P(t) {
  return Array.isArray(t) ? t : [t];
}
function w(t, c, r) {
  return S(t, c, {
    ...r,
    immediate: !0
  });
}
const k = I ? window : void 0;
function p(t) {
  var c;
  const r = a(t);
  return (c = r?.$el) !== null && c !== void 0 ? c : r;
}
function T(...t) {
  const c = (o, i, l, d) => (o.addEventListener(i, l, d), () => o.removeEventListener(i, l, d)), r = j(() => {
    const o = P(a(t[0])).filter((i) => i != null);
    return o.every((i) => typeof i != "string") ? o : void 0;
  });
  return w(() => {
    var o, i;
    return [
      (o = (i = r.value) === null || i === void 0 ? void 0 : i.map((l) => p(l))) !== null && o !== void 0 ? o : [k].filter((l) => l != null),
      P(a(r.value ? t[1] : t[0])),
      P(C(r.value ? t[2] : t[1])),
      a(r.value ? t[3] : t[2])
    ];
  }, ([o, i, l, d], b, s) => {
    if (!o?.length || !i?.length || !l?.length) return;
    const v = O(d) ? { ...d } : d, g = o.flatMap((f) => i.flatMap((h) => l.map((m) => c(f, h, m, v))));
    s(() => {
      g.forEach((f) => f());
    });
  }, { flush: "post" });
}
function W(t, c, r = {}) {
  const { window: o = k, ignore: i = [], capture: l = !0, detectIframe: d = !1, controls: b = !1 } = r;
  if (!o) return b ? {
    stop: y,
    cancel: y,
    trigger: y
  } : y;
  let s = !0;
  const v = (e) => a(i).some((n) => {
    if (typeof n == "string") return Array.from(o.document.querySelectorAll(n)).some((u) => u === e.target || e.composedPath().includes(u));
    {
      const u = p(n);
      return u && (e.target === u || e.composedPath().includes(u));
    }
  });
  function g(e) {
    const n = a(e);
    return n && n.$.subTree.shapeFlag === 16;
  }
  function f(e, n) {
    const u = a(e), E = u.$.subTree && u.$.subTree.children;
    return E == null || !Array.isArray(E) ? !1 : E.some(($) => $.el === n.target || n.composedPath().includes($.el));
  }
  const h = (e) => {
    const n = p(t);
    if (e.target != null && !(!(n instanceof Element) && g(t) && f(t, e)) && !(!n || n === e.target || e.composedPath().includes(n))) {
      if ("detail" in e && e.detail === 0 && (s = !v(e)), !s) {
        s = !0;
        return;
      }
      c(e);
    }
  };
  let m = !1;
  const M = [
    T(o, "click", (e) => {
      m || (m = !0, setTimeout(() => {
        m = !1;
      }, 0), h(e));
    }, {
      passive: !0,
      capture: l
    }),
    T(o, "pointerdown", (e) => {
      const n = p(t);
      s = !v(e) && !!(n && !e.composedPath().includes(n));
    }, { passive: !0 }),
    d && T(o, "blur", (e) => {
      setTimeout(() => {
        var n;
        const u = p(t);
        ((n = o.document.activeElement) === null || n === void 0 ? void 0 : n.tagName) === "IFRAME" && !u?.contains(o.document.activeElement) && c(e);
      }, 0);
    }, { passive: !0 })
  ].filter(Boolean), A = () => M.forEach((e) => e());
  return b ? {
    stop: A,
    cancel: () => {
      s = !1;
    },
    trigger: (e) => {
      s = !0, h(e), s = !1;
    }
  } : A;
}
export {
  W as o
};
